// extracted by mini-css-extract-plugin
export var button = "_k8-0";
export var donut = "_k8-1";
export var donutFill = "_k8-3";
export var donutTrack = "_k8-2";